module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/picture-7cecf990b3001be1fff8ab02ef1b056b.svg";